// turnstile-guard.service.ts
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: 'root'
})
export class TurnstileGuardService implements CanActivate {
	expiry = Number(environment.turnstileExpiry);
	private readonly EXPIRATION_TIME = this.expiry * 60 * 1000;

	constructor(private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const turnstileDataString = localStorage.getItem('turnstileData');

		if (turnstileDataString) {
			try {
				const turnstileData = JSON.parse(turnstileDataString);
				const currentTime = Date.now();
				const isStillValid =
					turnstileData.verified &&
					(currentTime - turnstileData.timestamp) < this.EXPIRATION_TIME;

				if (isStillValid) {
					return true;
				}
			} catch (e) {
				// JSON parsing error, consider verification invalid
				console.error('Error parsing Turnstile data', e);
			}
		}

		// If we get here, either verification has expired or was never done
		// Remove expired data
		localStorage.removeItem('turnstileData');

		// Redirect to verification page with return URL
		this.router.navigate(['/'], {
			state: { returnUrl: state.url }
		});
		localStorage.setItem('returnUrl', state.url);
		return false;
	}
}
